var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoResultsSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 540,
    viewBox: "0 0 660 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Results"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background circle",
    cx: 330,
    cy: 298.875,
    r: 240,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.957 377.86H225.012C210.165 377.86 198.012 365.67 198.012 350.773V49.9554C198.012 35.0581 210.165 22.875 225.012 22.875H435.957C450.811 22.875 462.964 35.0581 462.964 49.9554V350.773C462.964 365.67 450.811 377.86 435.957 377.86Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.951 390.721H207.007C192.159 390.721 180.006 378.532 180.006 363.634V62.8167C180.006 47.9195 192.159 35.7363 207.007 35.7363H417.951C432.805 35.7363 444.958 47.9195 444.958 62.8167V363.634C444.958 378.532 432.805 390.721 417.951 390.721Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.437 400.876H189.056C174.178 400.876 162 388.737 162 373.902V74.3296C162 59.494 174.178 47.3613 189.056 47.3613H400.437C415.322 47.3613 427.5 59.494 427.5 74.3296V373.902C427.5 388.737 415.322 400.876 400.437 400.876Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.437 400.876H189.056C174.178 400.876 162 388.737 162 373.902V74.3296C162 59.494 174.178 47.3613 189.056 47.3613H400.437C415.322 47.3613 427.5 59.494 427.5 74.3296V373.902C427.5 388.737 415.322 400.876 400.437 400.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.968 138.63H213.837C209.378 138.63 205.729 135.158 205.729 130.916C205.729 126.669 209.378 123.196 213.837 123.196H369.968C374.426 123.196 378.076 126.669 378.076 130.916C378.076 135.158 374.426 138.63 369.968 138.63Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.968 184.934H213.837C209.378 184.934 205.729 181.462 205.729 177.22C205.729 172.972 209.378 169.5 213.837 169.5H369.968C374.426 169.5 378.076 172.972 378.076 177.22C378.076 181.462 374.426 184.934 369.968 184.934Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.968 231.235H213.837C209.378 231.235 205.729 227.763 205.729 223.521C205.729 219.279 209.378 215.801 213.837 215.801H369.968C374.426 215.801 378.076 219.279 378.076 223.521C378.076 227.763 374.426 231.235 369.968 231.235Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.968 277.539H213.837C209.378 277.539 205.729 274.066 205.729 269.824C205.729 265.577 209.378 262.104 213.837 262.104H369.968C374.426 262.104 378.076 265.577 378.076 269.824C378.076 274.066 374.426 277.539 369.968 277.539Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.335 323.839H213.872C209.394 323.839 205.729 320.367 205.729 316.125C205.729 311.878 209.394 308.405 213.872 308.405H295.335C299.813 308.405 303.478 311.878 303.478 316.125C303.478 320.367 299.813 323.839 295.335 323.839Z",
    fill: "#C7C7C7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.849 420.146C446.068 438.924 416.993 441.042 395.884 426.545C393.187 424.659 390.619 422.54 388.225 420.146C386.992 418.918 385.83 417.65 384.735 416.315C382.546 413.649 380.628 410.807 379.057 407.869C376.288 402.908 374.406 397.644 373.378 392.202C370.062 375.137 375.02 356.769 388.225 343.57C401.461 330.332 419.832 325.407 436.9 328.69C442.339 329.75 447.608 331.632 452.57 334.368C455.512 335.975 458.316 337.892 460.986 340.082C462.317 341.172 463.585 342.338 464.814 343.57C467.212 345.964 469.362 348.527 471.213 351.229C485.718 372.33 483.595 401.404 464.849 420.146Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.593 416.449C440.054 435.992 408.389 435.988 388.846 416.449C369.329 396.932 369.329 365.263 388.871 345.724C408.389 326.207 440.054 326.207 459.571 345.724C479.11 365.263 479.11 396.932 459.593 416.449ZM469.62 335.685C444.54 310.605 403.899 310.605 378.818 335.685C353.742 360.762 353.72 401.429 378.797 426.509C401.622 449.328 437.399 451.386 462.563 432.65C465.021 430.818 467.388 428.763 469.646 426.509C471.9 424.251 473.954 421.884 475.783 419.426C494.519 394.259 492.443 358.507 469.62 335.685Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.325 521.05L567.272 522.103C560.306 529.073 548.899 529.073 541.929 522.103L477.609 457.783L504.005 431.388L568.325 495.707C575.294 502.677 575.294 514.08 568.325 521.05Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.172 417.46L496.178 436.467L482.685 449.957L463.682 430.95C466.19 429.08 468.601 426.984 470.909 424.683C473.209 422.383 475.305 419.968 477.172 417.46Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.357 494.915L541.13 521.139L536.408 516.413L562.632 490.189L567.357 494.915Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.459 432.294L478.513 459.24L474.51 455.237L501.455 428.291L505.459 432.294Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.658 339.001L380.576 405.08C378.087 400.619 376.395 395.887 375.475 390.994L432.572 333.896C437.461 334.852 442.197 336.541 446.658 339.001Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.324 354.709L396.882 422.103C394.324 420.419 391.889 418.524 389.618 416.381C388.449 415.278 387.343 414.147 386.309 412.953L458.621 344.73C459.887 345.71 461.089 346.753 462.255 347.856C464.526 349.998 466.569 352.292 468.324 354.709Z",
    fill: "white",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    opacity: 0.5,
    cx: 78,
    cy: 85.875,
    r: 24,
    fill: "#E0E0E1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle_2",
    opacity: 0.5,
    cx: 594,
    cy: 403.875,
    r: 18,
    fill: "#E0E0E1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle_3",
    opacity: 0.5,
    cx: 75,
    cy: 439.875,
    r: 30,
    fill: "#E0E0E1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle_4",
    opacity: 0.5,
    cx: 630,
    cy: 163.875,
    r: 30,
    fill: "#E0E0E1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle_5",
    opacity: 0.5,
    cx: 573,
    cy: 58.875,
    r: 21,
    fill: "#E0E0E1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoResultsSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-no-results-search.426789d14126af1c031e4a4f59ca6f88.svg";